import LogoIconOnly from "@medoma/components/icons/LogoIconOnly";
import { Link, Outlet, useNavigate } from "react-router";
import { Trans } from "@lingui/react/macro";
import { Heading } from "@medoma/components/Heading/Heading";
import { FilledButton, OutlinedButton } from "@medoma/components/Button/Button";
import PlusIcon from "@medoma/components/icons/PlusIcon";
import FolderIcon from "@medoma/components/icons/FolderIcon";
import { SiteSwitcher } from "@/components/SiteSwitcher/SiteSwitcher";
import { IntercomButton } from "@medoma/support/IntercomButton";
import { CategoriesList } from "./CategoriesList";
import styles from "./EquipmentManagement.module.scss";

export const EquipmentManagement = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.equipmentManagementContainer}>
      <header className={styles.header}>
        <nav className={styles.nav}>
          <Link to="/" className={styles.logo}>
            <LogoIconOnly />
          </Link>
          <SiteSwitcher />
        </nav>
        <IntercomButton />
      </header>
      <main className={styles.main}>
        <div className={styles.left}>
          <div className={styles.mainHeader}>
            <Heading level="h1">
              <Trans>Hantera utrustning</Trans>
            </Heading>
            <div className={styles.actions}>
              <OutlinedButton
                size="small"
                onClick={() => navigate("categories/new")}
              >
                <FolderIcon />
                <Trans>Skapa kategori</Trans>
              </OutlinedButton>
              <FilledButton size="small" onClick={() => navigate("assets/new")}>
                <PlusIcon />
                <Trans>Lägg till utrustning</Trans>
              </FilledButton>
            </div>
          </div>
          <CategoriesList />
        </div>
        <aside className={styles.right}>
          <Outlet />
        </aside>
      </main>
    </div>
  );
};
